export const END_CONTENT_MIN_WIDTH = 320;
export const END_CONTENT_DEFAULT_WIDTH = 450;
const MIN_MAIN_WIDTH_RATIO = 1 / 4;

/**
 * Widest the end panel may grow while the main content keeps a quarter of the
 * space shared with it (and never less than the panel's own minimum width).
 */
export function getMaxEndContentWidth(
  rowWidth: number | undefined,
  railWidth = 0,
) {
  if (rowWidth == null) {
    return undefined;
  }
  const sharedWidth = rowWidth - railWidth;
  const mainReserve = Math.max(
    END_CONTENT_MIN_WIDTH,
    Math.round(sharedWidth * MIN_MAIN_WIDTH_RATIO),
  );
  return Math.max(END_CONTENT_MIN_WIDTH, sharedWidth - mainReserve);
}

export function resolveEndContentWidth({
  maxWidth,
  width,
}: {
  maxWidth?: number;
  width?: number | 'auto';
}): number | 'auto' {
  if (width === 'auto') {
    return 'auto';
  }
  return Math.min(width ?? END_CONTENT_DEFAULT_WIDTH, maxWidth ?? Infinity);
}
